import { regex } from "./regex";

export const loginFormValidation = {
  email: {
    validation: {
      required: {
        text: "Mandatory field",
      },
      invalid: {
        regex: regex.email,
        text: "Invalid email",
      },
    },
  },
  password: {
    validation: {
      required: {
        text: "Mandatory field",
      },
    },
  },
};
